var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.001 16H2.00101C0.896437 16 0.00100708 15.1046 0.00100708 14V3C0.00100708 1.89543 0.896437 1 2.00101 1H6.00101V3H2.00101V14H13.001V10H15.001V14C15.001 15.1046 14.1056 16 13.001 16ZM7.70101 9.707L6.29101 8.293L12.584 2H9.00101V0H16.001V7H14.001V3.415L7.70101 9.707Z","fill":"black"}));
}

ExternalLink.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
